import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout-only route. The list lives in admin.returns.index.tsx and the read-only
// detail in admin.returns.$id.tsx; both render through this Outlet. Without it,
// navigating to /admin/returns/$id kept the parent mounted with no slot for the
// child, so the detail page never opened (you stayed stuck on the table).
export const Route = createFileRoute('/admin/returns')({
  component: () => <Outlet />,
});
